import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import BackButton from '@/components/BackButton.vue';
const speciesModule = namespace('species');
let CharactersSpecies = class CharactersSpecies extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = this.isInHandbook ? 'Species | Handbook' : 'Species';
        this.numWordMap = {
            one: 1,
            two: 2,
            four: 4
        };
    }
    created() {
        this.fetchSpecies();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        const page = this.isInHandbook ? 'rules/phb' : 'characters';
        return _(this.species)
            .filter(({ contentType }) => !this.isInHandbook || contentType === 'Core')
            .map(species => ({
            ...species,
            to: `/${page}/species/${species.name}`
        })).value();
    }
    get headers() {
        return [
            {
                value: 'imageUrls',
                render: (value) => value[0],
                sortable: false,
                isImage: true
            },
            { text: 'Name', value: 'name' },
            {
                text: 'Ability Score Increase',
                value: 'abilitiesIncreased',
                isMultiSelect: true,
                filterChoices: ['Strength', 'Dexterity', 'Constitution', 'Intelligence', 'Wisdom', 'Charisma'],
                render: (value) => value.map(broadChoices => broadChoices.map(({ abilities, amount }) => `${abilities.join(' or ')} +${amount}`).join(', ')).join('; '),
                filterFunction: ({ abilitiesIncreased }, filterValue) => {
                    return abilitiesIncreased.some(broadChoice => {
                        return filterValue.length <= _.reduce(broadChoice, (acc, value) => {
                            const freeChoices = this.numWordMap[value.abilities[0].split(' ')[1]] || 0;
                            const isMatch = Math.min(_.intersection(value.abilities, filterValue).length, 1);
                            return acc + freeChoices + isMatch;
                        }, 0);
                    });
                }
            },
            {
                text: 'Size',
                value: 'size',
                filterChoices: ['Medium', 'Small'],
                filterFunction: ({ size }, filterValue) => size === filterValue
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: this.isInHandbook ? ['PHB'] : ['PHB', 'EC'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    speciesModule.State
], CharactersSpecies.prototype, "species", void 0);
__decorate([
    speciesModule.Action
], CharactersSpecies.prototype, "fetchSpecies", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CharactersSpecies.prototype, "isInHandbook", void 0);
CharactersSpecies = __decorate([
    Component({
        components: {
            BackButton,
            SearchTable
        }
    })
], CharactersSpecies);
export default CharactersSpecies;
